import React, { Component } from 'react';
import { ChevronDown, CloseIcon, Profile } from '@dbk/ui-icons';
import { PALETTE } from '../../../constants';

class ProfileBar extends Component {

  render() {
    const {
      onBack,
      onClose,
      isOnline,
      name,
      hasItems
    } = this.props;
    return (
      <div className={hasItems ? 'profile-info bar margin-bottom-3' : 'profile-info bar margin-bottom-2'}>

        <ChevronDown width={15} color={PALETTE.secondaryText} className="back-icon icon" onClick={onBack} />
        <Profile color={PALETTE.secondaryText} className="profile-icon" height={30} width={30} />
        {isOnline && <div className="online" />}
        <div className="profile-name">{name}</div>

        <div className="icon-float-right cross-icon_dimension" onClick={onClose}>
          <CloseIcon width={10} color={PALETTE.secondaryText} className="icon cross-icon" />
        </div>

      </div>
    );
  }

}
export default ProfileBar;
